/**
 * Chat user class
 */
export default class {
  constructor (data) {
    this.name = data.token.data.me.name
    this.email = data.token.data.me.emails[0].address
    this.username = data.token.data.me.username
    this.pictureProfile = data.token.data.me.avatarUrl
    this.extension = data.extension
    this.smsCapable = data.is_sms_capable
    this.server = data.server.server
    this.authToken = data.token.data.authToken
    this.homeUrl = `${this.server}/home?resumeToken=${this.authToken}`
    this.chatUserId = data.chat_user_id
  }

  // in use in form
  formSelector () {
    return this.smsCapable
      ? ['Chat', 'SMS']
      : ['Chat']
  }
}
